import React from "react";
import BusTicketScreen from "../../../common/AllTickets/BusTicketScreen";
const UserBusTicket = () => {
  return <BusTicketScreen mode="user" />;
};
export default UserBusTicket;
